export default __webpack_public_path__ + "static/char-04-anr-aabc644d023f3e8028ed46da2d823c3f.webp";